export default __webpack_public_path__ + "static/media/790246002325979136.48d00b6d.png";